export const debounceDelay = 300

export const successStatuses = [
  'payment_approved',
  'payment_authorized',
  'waiting_payment',
  'payment_pending',
  'payment_in_process'
]
